import { Inline } from 'jsxstyle';
import * as React from 'react';

export const SemiBold: React.SFC<any> = props => (
    <Inline fontSize={19} {...props} fontWeight={500} />
);

export const Regular: React.SFC<any> = props => (
    <Inline fontSize={13} {...props} fontWeight={300} />
);



// WEBPACK FOOTER //
// ./src/Styling.tsx